import type { RootState } from '@forvalter/store';

import {
    createSaveFiltersThunk,
    createClearFiltersThunk,
} from '@forvalter/utils/rtkUtils';
import type { FilterTableKey } from './config';
import { filterTableConfig } from './config';
import { capitalize } from '@forvalter/utils/TypeScriptUtils';

type RegistryEntry = {
    selector: (state: RootState) => Array<Array<string>> | undefined;
    save: ReturnType<typeof createSaveFiltersThunk>;
    clear: ReturnType<typeof createClearFiltersThunk>;
};

export const filterRegistry = Object.fromEntries(
    Object.entries(filterTableConfig).map(
        ([key, { stateKey, storageKey, actionPrefix }]) => {
            const saveThunk = createSaveFiltersThunk(
                storageKey,
                `${actionPrefix}/save${capitalize(stateKey)}`,
            );
            const clearThunk = createClearFiltersThunk(
                storageKey,
                `${actionPrefix}/clear${capitalize(stateKey)}`,
            );

            return [
                key,
                {
                    selector: (state: RootState) => state.ux[stateKey],
                    save: saveThunk,
                    clear: clearThunk,
                } satisfies RegistryEntry,
            ];
        },
    ),
) as Record<FilterTableKey, RegistryEntry>;
